export default __webpack_public_path__ + "iconfont.786e7652.ttf";